import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function BackBtn(props) {
    const { isLogin, onActionHandler, addPatientBackBtn } = props;

    let navigate = useNavigate();

    const backHandler = () => {
        if (isLogin || addPatientBackBtn) {
            onActionHandler();
        }
        else navigate(-1);
    };

    return (
        <div>
            <Button style={{
                width: '38px',
                minWidth: '38px',
                height: '38px',
                borderRadius: '50%',
                border: isLogin ? 'none' : '1px solid #EEEEEE',
                boxShadow: isLogin ? 'none' : '-2px -2px 7px #FFFFFF, 1px 1px 10px rgba(0, 0, 0, 0.1)',
                backgroundColor: isLogin ? 'transparent' : '#FFFFFF',
                cursor: 'pointer',
            }}
                    onClick={backHandler}
                    round='true'
            >
                <ArrowBackIcon style={{ fontSize: 23, color: isLogin ? '#ffffff' : '#707070' }} />
            </Button>
        </div>
    );
}